import { render, staticRenderFns } from "./CardColumn.vue?vue&type=template&id=29848ab2&"
import script from "./CardColumn.vue?vue&type=script&lang=js&"
export * from "./CardColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports